export default __webpack_public_path__ + "assets/appleQrCodeCenter-e1a12f861d0c41b579521a281875dc26.svg";